export default function TobaccoUse() {
    return [
        { label: "Currently use", value: "true" },
        { label: "Never used", value: "false" },
    ]
};